// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1ZoMm","tab":"Tabs_tab__8R9GE","tabActive":"Tabs_tabActive__2vkhi"};